import closestTo from 'date-fns/closestTo';
import { ITrendData } from '../SocialArtistPerformanceTrend/types';
/**
 * Find the date in the trend data that is closest to the passed timestamp.
 * @param  {Date | null} timestamp timestamp (in ms)
 * @param  {Array}  trends    trend data
 * @return {Date}             date from trends' data that is closest to timestamp
 */
function getClosestDate(
  timestamp: Date | null,
  trends: any[]
): Date | undefined {
  const dates = trends.reduce((acc, el) => {
    el.data.forEach((d: ITrendData) => acc.push(d.date));
    return acc;
  }, []);

  return closestTo(timestamp as number | Date, dates);
}

export default getClosestDate;
